import { render } from "./HepaticsGallery.vue?vue&type=template&id=0a74534a"
import script from "./HepaticsGallery.vue?vue&type=script&lang=js"
export * from "./HepaticsGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__